import mapAComponent from './mapAComponent';
import objectAssign from 'object-assign';

function mergeOptions ($vm, options) {
  const defaults = {}
  for (let i in $vm.$options.props) {
    if (i !== 'value') {
      defaults[i] = $vm.$options.props[i].default
    }
  }
  const _options = objectAssign({}, defaults, options)
  for (let i in _options) {
    $vm[i] = _options[i]
  }
}

let MapAObj = {};
MapAObj.install = function (Vue) {
  Vue.prototype.$mapA = {};
  let mapMain = Vue.extend(mapAComponent);
  let instance = new mapMain({
    el: document.createElement('div')
  })

  let parent = document.getElementById('app')
  document.body.appendChild(instance.$el);
  Vue.prototype.$mapA.show  = (settings={})=>{
    instance =  Object.assign(instance, {
      show: true,
      mapHeight:680,
      longitude:116.404,
      latitude:39.915,
      description:'天安门',
      /*data:[],
      onOk(e){
        console.log(e)
        console.log('选中回调')
      },
      onCancel(){
        console.log('取消回调')
      }*/
    })
    mergeOptions(instance, settings)
  }
  Vue.prototype.$mapA.hide  = ()=>{
    instance.show = false
  }
}
export default MapAObj;



// WEBPACK FOOTER //
// ./src/components/comm/mapAComponent/index.js